import * as React from 'react';
import {Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, useTheme} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHardDrive} from "@fortawesome/free-solid-svg-icons";
import {Link, useLocation} from "react-router-dom";
import {SystemRoutes} from "../../../../Utils/RouteUtils";
import {Forward, Handyman, Sensors, SwapVert} from "@mui/icons-material";
import {useAppSelector} from "../../../../Config/Hooks";
import {hasPermission} from "../../../Auth/AuthenticationUtil";
import {AUTHORITIES} from "../../../../Config/Constants";


const style = {
    linkItem: {
        textDecoration: "none",
        color: "inherit"
    },
};


export default function SGDCommunicationMenu() {
    const location = useLocation();
    const theme = useTheme();
    const account = useAppSelector(state => state.authentication.account);
    const canViewCommands = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN,
        AUTHORITIES.VIEW_COMMAND_HISTORY
    ]);
    const canViewTeleobjects = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN,
        AUTHORITIES.VIEW_TELEOBJECT_INHIBITION
    ]);
    return (
            <Box sx={{
                      width: '100%',
                      maxWidth: 360,
                      bgcolor: theme.palette.mode === 'light' ? 'background.paper' : '#1E1E1E',
                      height: window.innerHeight - 90,
                      borderBottomLeftRadius: '16px',
                      borderBottomRightRadius: '16px',
                      ml: '2%',
                      mt: 1
            }}>
            <nav aria-label="main mailbox folders">
                <List>
                    {canViewCommands && (
                        <>
                            <Link style={style.linkItem} to={SystemRoutes.COMMUNICATION_INHIBIT_EQUIPMENTS}>
                                <ListItem disablePadding selected={location.pathname.includes("inhibit-equipments")}>
                                    <ListItemButton>
                                        <ListItemIcon>
                                            <Handyman/>
                                        </ListItemIcon>
                                        <ListItemText primary="Inibe/Habilita Equipamentos"/>
                                    </ListItemButton>
                                </ListItem>
                            </Link>
                            <Link style={style.linkItem} to={SystemRoutes.COMMUNICATION_SENT_TELECOMMAND}>
                                <ListItem disablePadding selected={location.pathname.includes("sent-telecommand")}>
                                    <ListItemButton>
                                        <ListItemIcon>
                                            <Forward/>
                                        </ListItemIcon>
                                        <ListItemText primary="Envio de Telecomandos"/>
                                    </ListItemButton>
                                </ListItem>
                            </Link>
                        </>
                    )}
                    {canViewTeleobjects && (
                        <Link style={style.linkItem} to={SystemRoutes.COMMUNICATION_TELEOBJECTS}>
                            <ListItem disablePadding selected={location.pathname.includes("teleobjects")}>
                                <ListItemButton>
                                    <ListItemIcon>
                                        <Sensors/>
                                    </ListItemIcon>
                                    <ListItemText primary="Inibe/Habilita Teleobjetos"/>
                                </ListItemButton>
                            </ListItem>
                        </Link>
                    )}
                    <Link style={style.linkItem} to={SystemRoutes.DASHBOARD_OVERVIEW}>
                        <ListItem disablePadding>
                            <ListItemButton disabled>
                                <ListItemIcon>
                                    <SwapVert/>
                                </ListItemIcon>
                                <ListItemText primary="Requisição/Resposta"/>
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={SystemRoutes.DASHBOARD_OVERVIEW}>
                        <ListItem disablePadding
                                  selected={location.pathname.includes("sss-configuration") && !location.pathname.includes("class")}>
                            <ListItemButton disabled>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive}/>
                                </ListItemIcon>
                                <ListItemText primary="Configuração de SSS"/>
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={SystemRoutes.DASHBOARD_OVERVIEW}>
                        <ListItem disablePadding selected={location.pathname.includes("equipment-type")}>
                            <ListItemButton disabled>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive}/>
                                </ListItemIcon>
                                <ListItemText primary="Inibe/Habilita Telessinais"/>
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={SystemRoutes.DASHBOARD_OVERVIEW}>
                        <ListItem disablePadding selected={location.pathname.includes("graph-element")}>
                            <ListItemButton disabled>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive}/>
                                </ListItemIcon>
                                <ListItemText primary="Inibe/Habilita Telemedidas"/>
                            </ListItemButton>
                        </ListItem>
                    </Link>

                    <Link style={style.linkItem} to={SystemRoutes.DASHBOARD_OVERVIEW}>
                        <ListItem disablePadding selected={location.pathname.includes("grafic_element")}>
                            <ListItemButton disabled>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive}/>
                                </ListItemIcon>
                                <ListItemText primary="Equipamentos"/>
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={SystemRoutes.DASHBOARD_OVERVIEW}>
                        <ListItem disablePadding
                                  selected={location.pathname.includes("tele-object") && !location.pathname.includes("Specification")}>
                            <ListItemButton disabled>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive}/>
                                </ListItemIcon>
                                <ListItemText primary="Pedido de Alarmes"/>
                            </ListItemButton>
                        </ListItem>
                    </Link>
                </List>
            </nav>
        </Box>
    );
}
